import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import PlannerPage from './pages/PlannerPage';
import HealthPage from './pages/HealthPage';
import SelfDevelopmentPage from './pages/SelfDevelopmentPage';
import Navigation from './components/Navigation';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/planner" element={<PlannerPage />} />
            <Route path="/health" element={<HealthPage />} />
            <Route path="/self-development" element={<SelfDevelopmentPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;